import { getUserFullName } from 'utils';
import { LeadBasicInfo } from '../../models/Dashboard';

export const getLeadName = ({ firstName, lastName, email }: LeadBasicInfo) => {
  const name = getUserFullName(firstName, lastName);

  return name ? `${name}${!lastName ? ` (${email})` : ''}` : email;
};
